import { ProfitStatistics } from "../../../models/Statistics";

export const REQUEST_PROFITSTATISTICS = "REQUEST_PROFITSTATISTICS";
export const REQUEST_PROFITSTATISTICS_DONE = "REQUEST_PROFITSTATISTICS_DONE";

export interface FetchProfitStatistics {
  type: typeof REQUEST_PROFITSTATISTICS;
  payload: ReadonlyArray<ProfitStatistics>;
}

export interface FetchProfitStatisticsDone {
  type: typeof REQUEST_PROFITSTATISTICS_DONE;
  payload: ReadonlyArray<ProfitStatistics>;
}

export interface ProfitsStatisticsState {
  isLoading: boolean;
  profitStatistics: ReadonlyArray<ProfitStatistics>;
}

export type ProfitStatisticsActions =
  | FetchProfitStatistics
  | FetchProfitStatisticsDone;
